<ng-container *ngIf="isLoggedIn">
  <div class="my-submissions-page tanuh-themed-page">
    <app-asset-header [config]="headerConfig" variant="tanuh"></app-asset-header>

    <div class="my-submissions-page__content">
      <div class="my-submissions-page__main">
        <div class="my-submissions-page__inner">
          <app-my-submissions [showPanelHeader]="false"></app-my-submissions>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</ng-container>

<app-login-modal
  *ngIf="showLoginModal"
  [redirectUri]="loginRedirectUri"
  (visibleChange)="onLoginModalClose($event)"
></app-login-modal>
